import api from '@/api/base';

const URLS = {
  sendMessage: '/chat-widget/message',
} as const;

const chatWidgetApi = {
  sendMessage: (payload: Record<string, unknown>) => {
    return api.post<unknown>(URLS.sendMessage, payload);
  },
};

export default chatWidgetApi;
